import dayjs, { Dayjs } from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { DATE_TIME_REGEX, SCHEDULING_CONSTANTS } from "./constants";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export const isValidTimeFormat = (time: string): boolean => {
  return DATE_TIME_REGEX.test(time);
};

export const isDateInPast = (date: Dayjs | null): boolean => {
  if (!date || !date.isValid()) return false;
  const hasTime = date.hour() !== 0 || date.minute() !== 0 || date.second() !== 0;
  return hasTime ? date.isBefore(dayjs()) : date.isBefore(dayjs().startOf("day"));
};

export const isDateInRange = (date: Dayjs, startDate?: Dayjs, endDate?: Dayjs): boolean => {
  if (!startDate || !endDate) return true;
  const dayStart = date.startOf("day");
  const start = startDate.startOf("day");
  const end = endDate.endOf("day");
  return dayStart.isSameOrAfter(start) && dayStart.isSameOrBefore(end);
};

export const parseHourToDayjs = (baseDay: Dayjs, timeString: string): Dayjs => {
  const [hours, minutes] = timeString.split(":").map((value) => parseInt(value, 10));
  return baseDay.hour(hours).minute(minutes).second(0);
};

export const formatDateForDisplay = (date: string): string => {
  return dayjs(date).format(SCHEDULING_CONSTANTS.DISPLAY_DATE_FORMAT);
};

export const formatDateTimeForAPI = (date: Dayjs): string => {
  return date.format(SCHEDULING_CONSTANTS.DATE_FORMAT);
};

export const sortSchedulesByDate = (
  schedules: { date: string; sent?: boolean }[]
): { date: string; sent?: boolean }[] => {
  return [...schedules].sort((a, b) => {
    const dateA = new Date(a.date).getTime();
    const dateB = new Date(b.date).getTime();
    return dateA - dateB;
  });
};

export const filterNewDates = (
  newDates: string[],
  existingSchedules: { date: string }[]
): string[] => {
  return newDates.filter(
    (newDate) => !existingSchedules.some((existing) => existing.date === newDate)
  );
};

export const createScheduleFromDate = (date: string, sent = false) => ({
  date,
  sent,
});
